export default __webpack_public_path__ + "static/media/info-icon-outline.55dc5dd2.svg";